/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TransparencyRouteImport } from './routes/transparency'
import { Route as ReferralsRouteImport } from './routes/referrals'
import { Route as PlayRouteImport } from './routes/play'
import { Route as HowToPlayRouteImport } from './routes/how-to-play'
import { Route as EarnRouteImport } from './routes/earn'
import { Route as IndexRouteImport } from './routes/index'
import { Route as GovernanceIndexRouteImport } from './routes/governance/index'
import { Route as GovernanceProposalRouteImport } from './routes/governance/proposal'

const TransparencyRoute = TransparencyRouteImport.update({
  id: '/transparency',
  path: '/transparency',
  getParentRoute: () => rootRouteImport,
} as any)
const ReferralsRoute = ReferralsRouteImport.update({
  id: '/referrals',
  path: '/referrals',
  getParentRoute: () => rootRouteImport,
} as any)
const PlayRoute = PlayRouteImport.update({
  id: '/play',
  path: '/play',
  getParentRoute: () => rootRouteImport,
} as any)
const HowToPlayRoute = HowToPlayRouteImport.update({
  id: '/how-to-play',
  path: '/how-to-play',
  getParentRoute: () => rootRouteImport,
} as any)
const EarnRoute = EarnRouteImport.update({
  id: '/earn',
  path: '/earn',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const GovernanceIndexRoute = GovernanceIndexRouteImport.update({
  id: '/governance/',
  path: '/governance/',
  getParentRoute: () => rootRouteImport,
} as any)
const GovernanceProposalRoute = GovernanceProposalRouteImport.update({
  id: '/governance/proposal',
  path: '/governance/proposal',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/earn': typeof EarnRoute
  '/how-to-play': typeof HowToPlayRoute
  '/play': typeof PlayRoute
  '/referrals': typeof ReferralsRoute
  '/transparency': typeof TransparencyRoute
  '/governance/proposal': typeof GovernanceProposalRoute
  '/governance': typeof GovernanceIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/earn': typeof EarnRoute
  '/how-to-play': typeof HowToPlayRoute
  '/play': typeof PlayRoute
  '/referrals': typeof ReferralsRoute
  '/transparency': typeof TransparencyRoute
  '/governance/proposal': typeof GovernanceProposalRoute
  '/governance': typeof GovernanceIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/earn': typeof EarnRoute
  '/how-to-play': typeof HowToPlayRoute
  '/play': typeof PlayRoute
  '/referrals': typeof ReferralsRoute
  '/transparency': typeof TransparencyRoute
  '/governance/proposal': typeof GovernanceProposalRoute
  '/governance/': typeof GovernanceIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/earn'
    | '/how-to-play'
    | '/play'
    | '/referrals'
    | '/transparency'
    | '/governance/proposal'
    | '/governance'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/earn'
    | '/how-to-play'
    | '/play'
    | '/referrals'
    | '/transparency'
    | '/governance/proposal'
    | '/governance'
  id:
    | '__root__'
    | '/'
    | '/earn'
    | '/how-to-play'
    | '/play'
    | '/referrals'
    | '/transparency'
    | '/governance/proposal'
    | '/governance/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  EarnRoute: typeof EarnRoute
  HowToPlayRoute: typeof HowToPlayRoute
  PlayRoute: typeof PlayRoute
  ReferralsRoute: typeof ReferralsRoute
  TransparencyRoute: typeof TransparencyRoute
  GovernanceProposalRoute: typeof GovernanceProposalRoute
  GovernanceIndexRoute: typeof GovernanceIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/transparency': {
      id: '/transparency'
      path: '/transparency'
      fullPath: '/transparency'
      preLoaderRoute: typeof TransparencyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/referrals': {
      id: '/referrals'
      path: '/referrals'
      fullPath: '/referrals'
      preLoaderRoute: typeof ReferralsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/play': {
      id: '/play'
      path: '/play'
      fullPath: '/play'
      preLoaderRoute: typeof PlayRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/how-to-play': {
      id: '/how-to-play'
      path: '/how-to-play'
      fullPath: '/how-to-play'
      preLoaderRoute: typeof HowToPlayRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/earn': {
      id: '/earn'
      path: '/earn'
      fullPath: '/earn'
      preLoaderRoute: typeof EarnRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/governance/': {
      id: '/governance/'
      path: '/governance'
      fullPath: '/governance'
      preLoaderRoute: typeof GovernanceIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/governance/proposal': {
      id: '/governance/proposal'
      path: '/governance/proposal'
      fullPath: '/governance/proposal'
      preLoaderRoute: typeof GovernanceProposalRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  EarnRoute: EarnRoute,
  HowToPlayRoute: HowToPlayRoute,
  PlayRoute: PlayRoute,
  ReferralsRoute: ReferralsRoute,
  TransparencyRoute: TransparencyRoute,
  GovernanceProposalRoute: GovernanceProposalRoute,
  GovernanceIndexRoute: GovernanceIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
